/** Retire this origin's PWA without deleting user preferences or offline DBs. */
export async function retirePwa(): Promise<void> {
  const serviceWorkers = "serviceWorker" in navigator
    ? navigator.serviceWorker
    : undefined;
  const wasControlled = Boolean(serviceWorkers?.controller);
  const registrations = serviceWorkers
    ? await serviceWorkers.getRegistrations()
    : [];
  await Promise.all(
    registrations.map((registration) => registration.unregister()),
  );

  if (typeof caches !== "undefined") {
    const names = await caches.keys();
    await Promise.all(names.map((name) => caches.delete(name)));
  }

  // Unregistering alone does not detach the worker from the current document.
  // The fresh navigation has no registration and therefore cannot loop.
  if (wasControlled) {
    window.location.reload();
  }
}